module.exports = __webpack_public_path__ + "img/Marjorie_Buckley_2023.eeef81a7.jpg";